import { ROUTE_LOBBY } from '@/models/Route';
import { useWindowSize } from '@react-hook/window-size';
import { useEffect } from 'react';

const NumOfDigits: number = 2;

export const useMaxWidth = () => {
    const [width, height] = useWindowSize({ wait: 100 });
    const isLobby = window.location.pathname.indexOf(ROUTE_LOBBY) !== -1;

    useEffect(() => {
        let vh = (height * 0.01).toFixed(NumOfDigits);
        document.documentElement.style.setProperty('--vh', `${vh}px`);
        document.documentElement.style.setProperty('--vhNumber', `${vh}`);
    }, [height]);

    useEffect(() => {
        let vw = width * 0.01;

        if (isLobby && width > 3840) {
            vw = 38.4;
        }
        document.documentElement.style.setProperty(
            '--vw',
            `${vw.toFixed(NumOfDigits)}px`
        );
    }, [width, height, isLobby]);
};
